module.exports = __webpack_public_path__ + "img/sj.c2c7ea86.png";